/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalAuthSubmissionLeadScreenerLeadInfoState
 */
export interface PalAuthSubmissionLeadScreenerLeadInfoState {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    name?: string;
    /**
     * 
     */
    code?: string;
    /**
     * 
     */
    country_id?: string;
}

/**
 * Check if a given object implements the PalAuthSubmissionLeadScreenerLeadInfoState interface.
 */
export function instanceOfPalAuthSubmissionLeadScreenerLeadInfoState(value: object): value is PalAuthSubmissionLeadScreenerLeadInfoState {
    return true;
}

export function PalAuthSubmissionLeadScreenerLeadInfoStateFromJSON(json: any): PalAuthSubmissionLeadScreenerLeadInfoState {
    return PalAuthSubmissionLeadScreenerLeadInfoStateFromJSONTyped(json, false);
}

export function PalAuthSubmissionLeadScreenerLeadInfoStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthSubmissionLeadScreenerLeadInfoState {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'code': json['code'] == null ? undefined : json['code'],
        'country_id': json['country_id'] == null ? undefined : json['country_id'],
    };
}

export function PalAuthSubmissionLeadScreenerLeadInfoStateToJSON(json: any): PalAuthSubmissionLeadScreenerLeadInfoState {
    return PalAuthSubmissionLeadScreenerLeadInfoStateToJSONTyped(json, false);
}

export function PalAuthSubmissionLeadScreenerLeadInfoStateToJSONTyped(value?: PalAuthSubmissionLeadScreenerLeadInfoState | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'code': value['code'],
        'country_id': value['country_id'],
    };
}

